<template>
	<div class="login-main-div">
		<!-- <div class="brand-info">
			<h1>文案文案文案文案文案</h1>
			<p>用来干嘛干嘛干嘛干嘛干嘛干嘛干嘛干嘛干嘛干嘛干嘛干嘛干嘛干嘛干嘛干嘛</p>
		</div> -->
		<div class="login-main" :style="'width:' + getLoginWidth()">
			<router-view></router-view>

<!--			<el-tabs v-model="activeName">-->
<!--				<el-tab-pane label="登录" name="login">-->
<!--					<login-sub></login-sub>-->
<!--				</el-tab-pane>-->
<!--				<el-tab-pane label="注册" name="register">-->
<!--					<register-sub></register-sub>-->
<!--				</el-tab-pane>-->
<!--			</el-tabs>-->
		</div>
	</div>
</template>

<script>
import LOGIN_SUB from '@/components/template/sign/login.vue'
import REGISTER_SUB from '@/components/template/sign/register.vue'
import RESET_PWD_SUB from '@/components/template/sign/resetPwd.vue'

export default {
	name: 'signIndex',
	inject: ['WINDOW','F_alertMsg','F_windowLoading','F_getErrMSg'],
	data() {return {
		windowObj : this.WINDOW,
		activeName : 'login'
	}},
	components:{
		'login-sub' : LOGIN_SUB,
		'register-sub' : REGISTER_SUB,
		'resetPwd-sub' : RESET_PWD_SUB
	},
	created() {},
	methods:{
		getLoginWidth : function(){
			let le = this.$data.windowObj.width_level
			let wi = '400px'
			if(le == 1){
				wi = '90%'
			}
			return wi
		}
	},
	watch:{
		windowObj:{
			handler(){},
			deep:true
		}
	}
}
</script>

<style scoped>
.login-main-div{

	background-image:url(../../../assets/img/login-bg.jpg);
	height: calc(100vh - 60px);
	background-size:auto 100%;
}
.brand-info{
	color: #fff;
	margin: 220px 560px 0 90px;
	line-height: 1.15;
	letter-spacing:5px;
}
.login-main{
	position: absolute;
	top: 0px;
	bottom: 0px;
	right: 0px;
	padding: 130px 5%;
	background-color: #fff;
}
</style>
